// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__bi1jP","content":"ManualTimeModal_content__3vp20"};